import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeLiveMqtt'
})
export class PipeLiveMqtt implements PipeTransform {
    constructor() { }
    transform(live) {

        let mins = (live / 2)
        let hrs = ((live / 2) / 60)

        if (mins < 60) {
            return mins.toFixed(0) + ' Mins'
        }else if(mins >= 60 && hrs <= 5) {
            return hrs.toFixed(0) + ' Hrs'
        }else if(hrs > 5)  {
            return 'Offline'
        }else  {
            return
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeLiveMqtt.ts